import { Component, Input, HostBinding } from '@angular/core';

import { SocialNavItem, mainNavSocialListModel } from '../../models';


@Component({
  selector: 'unh-social-menu',
  templateUrl: './social-menu.component.html',
  styleUrls: ['./social-menu.component.scss']
})

export class SocialMenuComponent {
  @Input() navItemList: SocialNavItem[] = mainNavSocialListModel;

  @HostBinding('class.isVisible')
  @Input() isVisibleSocialMenu = false;
}
